'use strict';

const Backbone = require('backbone/backbone');

require('./Gallery.less');
require('slick-carousel');
var GalleryPopupTemplate = require('./GalleryPopupRuntime.html');
var GalleryPopup = require('./GalleryPopup.js');

module.exports = Backbone.View.extend({

    el: '.Gallery',

    events: {
        'click .Gallery-slide': 'onFullscreenClick'
    },

    initialize: function () {
        setTimeout(() => {
            this.$('.Gallery-slides').slick({
                adaptiveHeight: false,
                prevArrow: this.$('.Gallery-prevArrow'),
                nextArrow: this.$('.Gallery-nextArrow'),
                draggable: true
            });

            const $counter = this.$('.Gallery-counter span');
            const $descriptions = this.$('.Gallery-description');
            this.currentSlide = 0;
            const self = this;

            this.$('.Gallery-slides').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                $counter.text(nextSlide + 1);
                $descriptions.eq(nextSlide).addClass('active')
                    .siblings()
                    .removeClass('active');
                self.currentSlide = nextSlide;
            });
        }, 2000);
    },

    onFullscreenClick: function (e) {
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        if (isMobile) {
            return;
        }

        const key = $(e.currentTarget).attr('data-key');
        const slug = key.split('_')[0];
        const index = key.split('_')[1];
        const data = window.app.data.filter(item => item.slug === slug)[0].content[index];
        const $galleryPopupTemplate = $(GalleryPopupTemplate.render({data}));
        $('body').append($galleryPopupTemplate);
        $galleryPopupTemplate.hide().fadeIn(300);
        window.document.documentElement.classList.add('hasActiveModals');
        (new GalleryPopup({el: $galleryPopupTemplate[0], currentSlide: this.currentSlide}));
    }
});
